import React from "react"
import {
    Box,
    Button,
    Grid,
    TextField
  } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { utcIntialDate } from "../../../utils/dateHelper"
import { DateTime } from "luxon"
import { Filter } from "../../../components/_WMS/FilterComponent"
import { WorkOrderRecall } from "../entities/WorkOrderRecall"
import { updateWorkOrderRecall } from "../api"
import { useApi } from "../../../hooks/useApi"


interface EditWorkOrderRecallModalProps {
    workOrderRecall: WorkOrderRecall
    handleSnackbar: (message: string, success: boolean) => void
    handleCloseModal: () => void
    requestWorkOrderRecall : (
      filters?: Filter[],
      page?: number,
      pageSize?: number) => void
  }
/*
  export const validationSchema = Yup.object().shape({
    LPN: Yup.string()
      .trim()
      .min(1, 'Se requiere al menos un caracter')
      .required('LPN/Tote es obligatorio')
  })
*/
export const EditWorkOrderRecallModal: React.FC<EditWorkOrderRecallModalProps> = ({
    workOrderRecall,
    handleSnackbar,
    handleCloseModal,
    requestWorkOrderRecall: requestWorkOrderRecall
  }) => {

        const {callApi } = useApi()

        const handleSubmit = async (values: any) => {

          const finalValues: WorkOrderRecall = {
            ...values,
            promiseDate:values.promiseDate ? utcIntialDate(values.promiseDate as string): null,
          };

          callApi(updateWorkOrderRecall(values.workOrderId, finalValues))
          .then(() => {
            requestWorkOrderRecall()
            handleSnackbar('Entidad editada correctamente', true)
            handleCloseModal()
          })
          .catch((error) => {
            console.log('otro error:' + JSON.stringify(error))
            handleSnackbar('Error al editar: '+ error, false)
          })
        }

        //se combierte la fecha, al formato aceptado por el componente
        const convertToDateInputFormat = (dateTime: string | Date | undefined): string => {
          if (!dateTime) {
            return '';
          }
        
          const date = typeof dateTime === 'string' 
            ? DateTime.fromISO(dateTime) // Parsear desde un ISO string
            : DateTime.fromJSDate(dateTime); // Parsear desde un objeto Date
        
          return date.toFormat('yyyy-MM-dd'); // Convertir al formato YYYY-MM-DD
        };
          

          const transformedOrderRecall = {
            ...workOrderRecall,
            promiseDate: convertToDateInputFormat(workOrderRecall.promiseDate),

          };

          return (
            <Formik
              initialValues={transformedOrderRecall}
              onSubmit={async (values, { setSubmitting }) => {
                try {
                  await handleSubmit(values);
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              {({
                isSubmitting,
              }) => (
                <Box component={Form}>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                    <Field name="workOrderId">
                    {({ field }: any) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="ID"
                        variant="outlined"
                        InputProps={{ readOnly: true }}
                      />
                    )}
                    </Field>
                    </Grid>
                    <Grid item xs={12} sm={6}></Grid>
                  <Grid item xs={12} sm={6}>
                    <Field name="workOrderTag">
                    {({ field }: any) => (
                    <TextField
                      {...field}
                      fullWidth
                      label="Tag"
                      variant="outlined"
                    />
                    )}
                    </Field>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                  <Field name="promiseDate">
                    {({ field }: any) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Fecha de Compromiso"
                        type="date"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  </Field>
                  </Grid>

                    <Grid item xs={12}>
                      <Box display='flex' justifyContent='flex-end'>
                        <Button
                          fullWidth
                          variant='contained'
                          color='primary'
                          type='submit'
                          disabled={isSubmitting}
                        >
                          Guardar
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Formik>
      )
  }